import { gql } from '@apollo/client';
const ASSIGNED_LANDLORDS = gql`
  query ASSIGNED_LANDLORDS {
    listLandlordsManager {
      landlordsManager {
        landlordId
      }
    }
  }
`;

export const QUERY_University = gql`
  query University($slug: String) {
    university(slug: $slug) {
      name
      slug
    }
  }
`;

export const FIND_LANDLORDS = gql`
  query FIND_LANDLORDS($name: NonEmptyString) {
    listManageLandlords(name: $name) {
      landlords {
        id
        name
        billingCountry {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_SEARCH_PARTNER_CONTACTS = gql`
  query CMS_Partner_Contacts($pageSize: Int, $pageNumber: Int, $partnerName: NonEmptyString) {
    partnerContacts(pageSize: $pageSize, pageNumber: $pageNumber, partnerName: $partnerName) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          partner {
            name
            id
          }
        }
      }
    }
  }
`;

export const LIST_STAFFUSERS = gql`
  query listStaffUsers(
    $name: NonEmptyString
    $pageSize: PositiveInteger = 10
    $pageNumber: PositiveInteger = 1
  ) {
    listStaffUsers(pageSize: $pageSize, pageNumber: $pageNumber, name: $name) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          name
          id
        }
      }
    }
  }
`;

export const LIST_Landlord = gql`
  query listLandlords(
    $name: NonEmptyString
    $pageSize: PositiveInteger = 10
    $pageNumber: PositiveInteger = 1
  ) {
    landlords(pageSize: $pageSize, pageNumber: $pageNumber, name: $name) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          name
          id
        }
      }
    }
  }
`;

export const SIGNUP_LANDLORD = gql`
  mutation signupLandlord($input: ManageLandlordsInput!) {
    manageLandlords(input: $input) {
      result
    }
  }
`;

export const GET_MANUAL_BOOKING_LIST = gql`
  query CMS_listOpportunities(
    $pageSize: PositiveInteger = 10
    $pageNumber: PositiveInteger = 1
    $cityIds: [ID]
    $completedAtEnd: Datetime
    $completedAtStart: Datetime
    $countryIds: [ID]
    $createdAtEnd: Datetime
    $createdAtStart: Datetime
    $destinationUniversity: NonEmptyString
    $finalMoveInDateEnd: Datetime
    $finalMoveInDateStart: Datetime
    $finalMoveOutDateEnd: Datetime
    $finalMoveOutDateStart: Datetime
    $landlordBookingStatuses: [LandlordBookingStatus]
    $landlordIds: [ID]
    $market: OpportunityDestinationMarketEnum
    $opportunityIds: [ID]
    $partnerCode: NonEmptyString
    $propertyIds: [ID]
    $propertyName: NonEmptyString
    $referenceId: NonEmptyString
    $secondaryLandlordBookingStatus: SecondaryLandlordBookingStatus
    $sortBy: ListOpportunitiesSortBy = UPDATED_AT
    $sortDirection: SortDirection = DESCENDING
    $staffUserIds: [ID]
    $status: [OpportunityStage]
    $studentEmail: NonEmptyString
    $studentExternalId: NonEmptyString
    $studentFullName: NonEmptyString
    $studentIds: [ID]
    $studentInternalId: NonEmptyString
    $studentRegisteredPhone: NonEmptyString
    $tenancyLength: Int
    $tenancyLengthUnit: Int
  ) {
    listOpportunities(
      cityIds: $cityIds
      completedAtEnd: $completedAtEnd
      completedAtStart: $completedAtStart
      countryIds: $countryIds
      createdAtEnd: $createdAtEnd
      createdAtStart: $createdAtStart
      destinationUniversity: $destinationUniversity
      finalMoveInDateEnd: $finalMoveInDateEnd
      finalMoveInDateStart: $finalMoveInDateStart
      finalMoveOutDateEnd: $finalMoveOutDateEnd
      finalMoveOutDateStart: $finalMoveOutDateStart
      landlordBookingStatuses: $landlordBookingStatuses
      landlordIds: $landlordIds
      market: $market
      opportunityIds: $opportunityIds
      pageNumber: $pageNumber
      pageSize: $pageSize
      partnerCode: $partnerCode
      propertyIds: $propertyIds
      propertyName: $propertyName
      referenceId: $referenceId
      secondaryLandlordBookingStatus: $secondaryLandlordBookingStatus
      sortBy: $sortBy
      sortDirection: $sortDirection
      staffUserIds: $staffUserIds
      status: $status
      studentEmail: $studentEmail
      studentExternalId: $studentExternalId
      studentFullName: $studentFullName
      studentIds: $studentIds
      studentInternalId: $studentInternalId
      studentRegisteredPhone: $studentRegisteredPhone
      tenancyLength: $tenancyLength
      tenancyLengthUnit: $tenancyLengthUnit
    ) {
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      edges {
        node {
          id
          stage
          referenceId
          market
          partnerCode
          stage
          completedAt
          createdAt
          ownedById
          tenancyDurationDaysWeeks {
            days
            weeks
          }

          landlordBookingStatus
          destinationUniversity
          finalPrice
          currency
          agentServiceFeeInRmb
          ownedByUser {
            id
            name
          }
          contacts {
            name
          }
          destinationUniversity
          landlordApplicationId
          landlordApplicationSystem
          interestedXbooking {
            id
            propertyName
            landlordName
            roomName
            roomType
            referenceId
            landlordName
            listingMoveIn
            currency
            commission {
              invoiceNumber
              value
              actualInvoicedValue
              bonusCalculationType
              bonusCalculationValue
              totalCommissionValue
              bonusValue
              calculationType
              calculationValue
              currency
              firstInvoicedAt
              id
              lastInvoicedAt
              outstandingClaimValue
              commissionConvertedUsd
              data
            }
            landlordName
          }

          finalMoveInDate
          finalMoveOutDate
          student {
            id
            fullName
            firstName
            lastName
            passportFirstName
            passportLastName
            emailAddress
            registeredPhone
            referenceId
            destinationUniversity
            studentMapping {
              externalId
              externalSystem
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_BOOKING = gql`
  query ListBook($bookingJourneys: [BookingJourney!]!, $states: [BookingState!]!) {
    listUnionBookings(bookingJourneys: $bookingJourneys, states: $states) {
      totalCount
      pageInfo {
        hasNextPage
        numPages
      }
    }
  }
`;

export default ASSIGNED_LANDLORDS;

export const QUERY_UNION_BOOKING_DETAIL = gql`
  query CMS_QueryUnionBookingDetail($referenceId: NonEmptyString!) {
    getUnionBooking(referenceId: $referenceId) {
      opportunity {
        finalMoveInDate
        finalMoveOutDate
        finalPrice
        stage
        referenceId
        currency
        landlordBookingStatus
        partnerCode
        createdAt
        completedAt
        landlordApplicationId
        contacts {
          name
        }
        agentServiceFeeInRmb
        student {
          passportFirstName
          passportLastName
          passportMiddleName
          emailAddress
          gender
          referenceId
          systemId
          dateOfBirth
          sourceRegion
          phoneNumber
          country
          state
          city
          addressLines
          postalCode
          destinationUniversity
        }
        interestedXbooking {
          billingCycle
          currency
          landlordName
          propertyName
          referenceId
          roomName
          roomType
          unitPrice
          commission {
            currency
            calculationType
            calculationValue
            bonusCalculationType
            bonusCalculationValue
            bonusValue
            totalCommissionValue
            commissionConvertedUsd
            value
            data
          }
        }
      }
      order {
        externalId
        paymentOnline
        id
        moveInDate
        moveOutDate
        referenceId
        billingCycle
        bookingJourney
        currency
        cancelledReason
        landlordConfirmedPayment
        paidAt
        cancellationDatetime
        cancellationPeriodType
        cancellationPeriodValue
        city {
          id
          name
          country {
            slug
          }
          slug
        }
        passportFirstName
        passportLastName
        paymentDuration
        confirmationDuration
        landlord {
          name
        }
        uploadFiles {
          name
          id
          source
          type
        }
        studentData
        student {
          lastName
          firstName
          passportFirstName
          passportLastName
          phoneNumber
          emailAddress
          gender
          dateOfBirth
          country
          state
          city
          addressLines
          postalCode
          nationality
          currentUniversity
          destinationUniversity
          studyMajor
          academicYear
          userUuid
        }
        listingId
        instalmentPlanType
        propertyName
        propertyId
        unitTypeId
        unitTypeName
        unitTypeCategory
        listingSalesPrice
        totalPrice
        totalRental
        totalFee
        totalDeposit
        secondaryStage
        counterOffers {
          discountValue
          discountType
          currency
          listingId
          stage
          id
          moveInDate
          moveOutDate
          unitTypeName
          unitTypeCategory
          unitTypeName
          totalPrice
          currency
          listingSalesPrice
          billingCycle
          totalPrice
          validPeriodHour
          createdAt
          updatedAt
          rejectReason
          instalmentPlanType
          rejectReason
          stage
          property {
            status
            name
            address
            slug
            city {
              id
              name
              slug
              country {
                slug
              }
            }
            addressLine2
            documentations {
              name
              check
              slug
            }
          }
          originOrder {
            billingCycle
            currency
            id
            property {
              status
              name
              slug
              city {
                id
                name
                country {
                  slug
                }
                slug
              }
              address
              addressLine2
            }
            instalmentPlanType
            listingDiscountType
            listingDiscountValue
            listingId
            listingMaxPrice
            listingMinPrice
            listingMoveIn
            listingMoveInType
            listingMoveOut
            listingMoveOutType
            listingSalesPrice
            listingTenancyLengthType
            listingTenancyLengthValue
            moveInDate
            moveOutDate
            totalDeposit
            totalFee
            totalRental
            totalPrice
            unitTypeCategory
            unitTypeId
            unitTypeName
          }
        }
        stage
        charges {
          id
          referenceId
          chargeAmount
          chargeCurrency
          paymentMethod
          tradeNo
          stripeChargeId
        }
        payments {
          amount
          currency
          id
          name
          paymentCategory
          updatedAt
          payThroughStcom
          price
          status
          orderChargeId
        }
        processes {
          modifierName
          currentStage
          updatedAt
          currentSecondaryStage
        }
        refunds {
          id
          referenceId
          refundType
          refundMethod
          status
          amount
          currency
          refundFrom
          refundTo
          refundedAt
          refundMethodDetails
          transactionNo
          isTransferred
          processes {
            createdAt
            currentStatus
          }
        }
        commissions {
          basePrice
          bonusCommissionTierType
          bonusCommissionTierValue
          bonusPrice
          commissionTierType
          commissionTierValue
          createdAt
          currency
          id
          orderId
          referenceId
          status
          totalPrice
          updatedAt
        }
        receivables {
          referenceId
          receivableType
          receivableMethod
          status
          amount
          currency
          invoiceNumber
          invoicedAt
          paidAt
          commission {
            totalPrice
            currency
          }
        }
        transfers {
          referenceId
          transferType
          amount
          currency
          status
          planningTransferDatetime
          actualTransferDatetime
          actualTransferDetails
          actualTransferMethod
        }
        property {
          status
          id
          name
          slug
          address
          addressLine2
          city {
            id
            name
            country {
              slug
            }
            slug
          }
          documentations {
            name
            check
            slug
          }
          commissionTiers {
            bonus
            capType
            capValue
            category
            convertedCalculationValue
            description
            fullyCalculatable
            id
            name
            percentageForReport
            retrospectiveCommission
            status
            tenancyLengthFrom
            tenancyLengthTo
            tenancyUnit
            type
            value
          }
        }
      }
    }
  }
`;

export const QUERY_REPORT_LANDLORD_COMMISSIONS = gql`
  query CMS_ReportLandlordCommissions($input: ReportLandlordCommissionsInput!) {
    reportLandlordCommissions(input: $input) {
      totalCount
      landlords {
        bookingNumber
        landlordName
        commissions {
          amount
          currency
        }
      }
    }
  }
`;

export const MUTATION_CANCEL_BOOKING = gql`
  mutation cancelBooking($input: CancelOrderOnCMSInput!) {
    cancelOrderOnCMS(input: $input) {
      order {
        id
      }
    }
  }
`;

export const QUERY_LISTORDERS = gql`
  query QUERY_LISTORDERS(
    $bookingJourneys: [ListingPlan]!
    $id: ID
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $propertyName: NonEmptyString
    $referenceId: NonEmptyString
    $sortBy: SortBy
    $sortDirection: SortDirection
    $stages: [OrderStage]
    $studentName: NonEmptyString
    $passportFullName: NonEmptyString
    $commissionTriggerPoint: CommissionTriggerPointType
  ) {
    listOrders(
      bookingJourneys: $bookingJourneys
      id: $id
      pageNumber: $pageNumber
      pageSize: $pageSize
      propertyName: $propertyName
      referenceId: $referenceId
      sortBy: $sortBy
      sortDirection: $sortDirection
      stages: $stages
      studentName: $studentName
      passportFullName: $passportFullName
      commissionTriggerPoint: $commissionTriggerPoint
    ) {
      edges {
        node {
          id
          stage
          passportFullName
          student {
            fullName
          }
          landlord {
            name
          }
          property {
            name
          }
          moveInDate
          moveOutDate
          tenancyLength {
            weeks
            days
          }
          commissions {
            currency
            totalPrice
          }
          commissionTriggerPoint
          canUpdateListOrderStage
          createdAt
          bookingJourney
          referenceId
          unitTypeId
          unitTypeName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const QUERY_LISTORDER_DETAIL = gql`
  query QUERY_LISTORDER_DETAIL(
    $bookingJourneys: [ListingPlan]!
    $id: ID
    $propertyName: NonEmptyString
    $referenceId: NonEmptyString
    $sortBy: SortBy
    $sortDirection: SortDirection
    $stages: [OrderStage]
    $studentName: NonEmptyString
  ) {
    listOrders(
      bookingJourneys: $bookingJourneys
      id: $id
      pageNumber: 1
      pageSize: 1
      propertyName: $propertyName
      referenceId: $referenceId
      sortBy: $sortBy
      sortDirection: $sortDirection
      stages: $stages
      studentName: $studentName
    ) {
      edges {
        node {
          id
          stage
          passportFullName
          commissionTriggerPoint
          canUpdateListOrderStage
          student {
            fullName
            phoneNumber
            emailAddress
          }
          landlord {
            name
          }
          unitTypeCategory
          property {
            status
            id
            name
            slug
            address
            bookingJourney
            addressLine2
            heroImage {
              source
            }
            city {
              id
              name
              country {
                slug
                name
              }
              slug
            }
            documentations {
              name
              check
              slug
            }
            paymentPlan {
              paymentOnline
            }
            commissionTiers {
              bonus
              capType
              capValue
              category
              convertedCalculationValue
              description
              fullyCalculatable
              id
              name
              percentageForReport
              retrospectiveCommission
              status
              tenancyLengthFrom
              tenancyLengthTo
              tenancyUnit
              type
              value
            }
          }
          externalId
          id
          studentData
          tenancyLength {
            days
            weeks
          }
          orderNotes {
            createdAt
            createdBy
            createdByName
            id
            note
            orderId
            updatedAt
            updatedBy
            updatedByName
          }
          totalPrice
          referenceId
          billingCycle
          moveInDate
          moveOutDate
          tenancyLength {
            weeks
            days
          }
          commissions {
            basePrice
            bonusCommissionTierType
            bonusCommissionTierValue
            bonusPrice
            commissionTierType
            commissionTierValue
            createdAt
            currency
            id
            orderId
            referenceId
            status
            totalPrice
            updatedAt
          }
          city {
            id
            name
            country {
              slug
            }
            slug
          }
          customFieldValues {
            id
            value
            customFieldInternalName
          }
          student {
            lastName
            firstName
            passportFirstName
            passportLastName
            passportMiddleName
            otherPreferences
            studyMajor
            dateOfBirth
            phoneNumber
            gender
            customFieldValues
            emailAddress
            country
            state
            city
            addressLines
            postalCode
            nationality
            currentUniversity
            destinationUniversity
            academicYear
            userUuid
          }
          stage
          createdAt
          bookingJourney
          propertyName
          unitTypeId
          unitTypeName

          studentData
          orderNotes {
            note
            createdAt
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;
